<script setup lang="ts">
import { ref, computed } from 'vue'
import { useRoute } from "vue-router";
import { useLanguage } from "../utils/useLanguage";

const { t } = useLanguage();

const emit = defineEmits(['update:vOpen'])
const route= useRoute();
const path = route.path
const year = computed(() => new Date().getFullYear());

</script>

<template>
     <footer class="footer bg-black-3">
        <div class="column-md flex column j-center a-center gap-20 gap-20-md p-40">
            <div>
                <img class="logo mt-80" src="/logo_2024.png" alt="">
            </div>
            <div class="flex j-center a-center gap-10">
                <a href="https://www.instagram.com/themimirdotcom/"><img class="s-25" src="/icon-instagram.png" alt=""></a>
                <a href="https://www.linkedin.com/company/91141334/admin/"><img class="s-25" src="/icon-linkedin.png" alt=""></a>
                <a href="https://www.tiktok.com/@themimirdotcom"><img class="s-25" src="/icon-tiktok.png" alt=""></a>
                <a href="https://www.youtube.com/channel/UCTI1XLnDIEApO3515rWLD_A"><img class="s-25" src="/icon-youtube.png" alt=""></a>
            </div>
            <div class="gap-80 gap-40-sm grid g-xs-2 g-col-4 mb-40">
                <nav class="flex column wrap gap-10 mb-20 gap-sm-10">
                    <p class="white-1 fw-bold fs-1r">{{ t('Service') }}</p>
                    <router-link class="white-1" to="/kickstart"><span class="sm"></span>{{ t('Kickstart') }}</router-link>
                    <router-link class="white-1" to="/video"><span class="sm"></span>{{ t('Watch') }}</router-link>
                    <router-link class="white-1" to="/read"><span class="sm"></span>{{ t('Read') }}</router-link>
                    <router-link class="white-1" to="/speak" ><span class="sm"></span>{{ t('Speak') }}</router-link>

                </nav>
                <nav class="flex column wrap gap-10 mb-20 gap-sm-10">
                    <p class="white-1 fw-bold fs-1r">{{ t('Personal') }}</p>
                    <router-link class="white-1" to="/user/center"><span class="sm"></span>{{ t('Learning Center') }}</router-link>
                    <router-link class="white-1" to="/setting"><span class="sm"></span>{{ t('Account Setting') }}</router-link>
                    <router-link class="white-1" to="/user/activities"><span class="sm"></span>{{ t('Activities') }}</router-link>
                    <router-link class="white-1" to="/user/vocabulary/notebook"><span class="sm"></span>{{ t('Notebook') }}</router-link>

                </nav>
                <nav class="flex column wrap gap-10 mb-20 gap-sm-10">
                    <p class="white-1 fw-bold fs-1r">{{ t('Subscription') }}</p>
                    <router-link class="white-1" to="/subscribe"><span class="sm"></span>{{ t('Subscribe') }}</router-link>
                    <a class="white-1" href="https://community.themimir.com" target="_blank">{{ t('Open Debate') }}</a>

                </nav>
                <nav class="flex column wrap gap-10 gap-sm-10">
                    <p class="white-1 fw-bold fs-1r">{{ t('About') }}</p>
                    <a href="/ESSA_Packet.pdf" target="_blank" class="white-1">ESSA</a>
                    <router-link class="white-1" to="/FAQs">{{ t('FAQs') }}</router-link>
                    <router-link class="white-1" to="/privacy-policy">{{ t('Privacy Policy') }}</router-link>
                    <router-link class="white-1" to="/contact">{{ t('Contact Us') }}</router-link>
                    <router-link class="white-1" to="/founder-story">{{ t('Founder Story') }}</router-link>
                </nav>
            </div>
            <p class="pre-wrap white-1 fs-075r">{{ t('copyright', { year }) }}</p>
        </div>
     </footer>
</template>    
<style scoped>
@import '../assets/css_lib/themimir.css';

</style>